var _circle, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "white",
    stroke: "#2A2D34"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_3598_27704",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 13,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 2,
    width: 13,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.23772C16 9.47618 15.5486 10.6143 14.794 11.5109L10.9608 17.8265C10.7679 18.1444 10.3077 18.1479 10.1099 17.8329L5.90427 11.1351C5.88829 11.1096 5.87492 11.0836 5.86404 11.0572C5.31708 10.2432 5 9.27575 5 8.23772C5 5.34501 7.46243 3 10.5 3C13.5376 3 16 5.34501 16 8.23772ZM10.5008 11.2671C12.4338 11.2671 14.0008 9.8277 14.0008 8.05213C14.0008 6.27655 12.4338 4.83716 10.5008 4.83716C8.56784 4.83716 7.00083 6.27655 7.00083 8.05213C7.00083 9.8277 8.56784 11.2671 10.5008 11.2671Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.23772C16 9.47618 15.5486 10.6143 14.794 11.5109L10.9608 17.8265C10.7679 18.1444 10.3077 18.1479 10.1099 17.8329L5.90427 11.1351C5.88829 11.1096 5.87492 11.0836 5.86404 11.0572C5.31708 10.2432 5 9.27575 5 8.23772C5 5.34501 7.46243 3 10.5 3C13.5376 3 16 5.34501 16 8.23772ZM10.5008 11.2671C12.4338 11.2671 14.0008 9.8277 14.0008 8.05213C14.0008 6.27655 12.4338 4.83716 10.5008 4.83716C8.56784 4.83716 7.00083 6.27655 7.00083 8.05213C7.00083 9.8277 8.56784 11.2671 10.5008 11.2671Z",
    fill: "#00A651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.794 11.5109L14.0289 10.867L13.9792 10.926L13.9392 10.992L14.794 11.5109ZM10.9608 17.8265L10.106 17.3076L10.9608 17.8265ZM10.1099 17.8329L10.9568 17.3012L10.9568 17.3012L10.1099 17.8329ZM5.90427 11.1351L6.75116 10.6033L6.75116 10.6033L5.90427 11.1351ZM5.86404 11.0572L6.78863 10.6762L6.75025 10.583L6.69405 10.4994L5.86404 11.0572ZM15.5591 12.1548C16.4566 11.0885 17 9.72522 17 8.23772H15C15 9.22714 14.6407 10.1401 14.0289 10.867L15.5591 12.1548ZM11.8157 18.3453L15.6489 12.0297L13.9392 10.992L10.106 17.3076L11.8157 18.3453ZM9.26306 18.3647C9.85635 19.3096 11.2368 19.2991 11.8157 18.3453L10.106 17.3076C10.2989 16.9897 10.7591 16.9862 10.9568 17.3012L9.26306 18.3647ZM5.05739 11.6669L9.26306 18.3647L10.9568 17.3012L6.75116 10.6033L5.05739 11.6669ZM4.93946 11.4381C4.97205 11.5172 5.01146 11.5937 5.05739 11.6669L6.75116 10.6033C6.76511 10.6255 6.77779 10.6499 6.78863 10.6762L4.93946 11.4381ZM4 8.23772C4 9.48337 4.38137 10.6437 5.03404 11.6149L6.69405 10.4994C6.2528 9.8428 6 9.06812 6 8.23772H4ZM10.5 2C6.95676 2 4 4.74724 4 8.23772H6C6 5.94277 7.96811 4 10.5 4V2ZM17 8.23772C17 4.74724 14.0432 2 10.5 2V4C13.0319 4 15 5.94277 15 8.23772H17ZM13.0008 8.05213C13.0008 9.19715 11.9632 10.2671 10.5008 10.2671V12.2671C12.9045 12.2671 15.0008 10.4583 15.0008 8.05213H13.0008ZM10.5008 5.83716C11.9632 5.83716 13.0008 6.9071 13.0008 8.05213H15.0008C15.0008 5.64599 12.9045 3.83716 10.5008 3.83716V5.83716ZM8.00083 8.05213C8.00083 6.9071 9.03846 5.83716 10.5008 5.83716V3.83716C8.09722 3.83716 6.00083 5.64599 6.00083 8.05213H8.00083ZM10.5008 10.2671C9.03846 10.2671 8.00083 9.19715 8.00083 8.05213H6.00083C6.00083 10.4583 8.09722 12.2671 10.5008 12.2671V10.2671Z",
    fill: "#2A2D34",
    mask: "url(#path-2-outside-1_3598_27704)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.be37e0501cb58c5636b4836239123d0b.svg";
export { ForwardRef as ReactComponent };